

































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";

import CurrentHoldingsChart from "@/shared/components/investments/drivewealth/CurrentHoldingsChart.vue";
import AdvisoryFunds from "@/shared/components/investments/drivewealth/AdvisoryFunds.vue";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import InvestmentTransferHistoryWidget from "@/shared/components/investments/InvestmentTransferHistoryWidget.vue";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    InvestmentTransferHistoryWidget,
    DrivewealthNavigation,
    CurrentHoldingsTable,
    AdvisoryFunds,
    CurrentHoldingsChart,
    GenericLoadingSpinner
  }
})
export default class InvestmentAccountPage extends Vue {
  formatCurrency = formatCurrency;

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthStore = useDrivewealthStore();

  @Prop() page: number;

  @Prop() routeToPages: (page: number) => Location;

  @Prop({required: false}) username: string;

  @Prop({required: false}) partnerId: number;

  @Prop({ required: false }) accountId: number;

  load () {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({
        username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
      });
    } else {
      this.drivewealthStore.loadDefaultAccount({ username: this.username, partnerId: this.partnerId });
      this.drivewealthStore.loadAccountSummary({ username: this.username, partnerId: this.partnerId });
    }
    this.drivewealthStore.loadHsaBalanceAndThreshold({
      username: this.username, partnerId: this.partnerId, accountId: this.accountId
    });
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("accountId")
  reload () {
    this.load();
  }

  mounted () {
    this.load();
  }

  get hasAnAccount (): boolean {
    if (this.accountId) {
      return this.drivewealthStore.accountSummaryById(this.accountId) !== undefined;
    } else {
      return this.drivewealthStore.hasAnAccount;
    }
  }

  get isLoaded () {
    if (this.accountId) {
      return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
    } else {
      return this.investmentDailyBalanceStore.currentBalanceIsLoaded &&
        this.drivewealthStore.drivewealthLoaded;
    }
  }
}
